<template>
  <div>
    <a-button
      type="primary"
      icon="plus"
      @click="showModal"
      style="margin-bottom: 20px"
      >{{ $t("all.add") }}</a-button
    >
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :title="$t('all.enterInformationBelow')"
      width="50%"
      :height="1200"
      :footer="false"
    >
      <a-form :form="form" @submit="addClass">
        <a-form-item :label="$t('etablissement.nom')">
          <a-input
            :placeholder="$t('etablissement.nom')"
            v-decorator="[
              'name',
              {
                rules: [
                  {
                    required: true,
                    message: $t('all.requiredName'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$t('etablissement.niveau')">
          <a-select
            @change="onCreateLevelChange"
            v-decorator="[
              'level',
              {
                rules: [
                  {
                    required: true,
                    message: $t('requis.niveau'),
                  },
                ],
              },
            ]"
            :placeholder="$t('choisir.niveauClass')"
          >
            <a-select-option
              v-for="(value, name, index) in levelSelectData"
              :key="index"
              :value="name"
              >{{ value }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-alert
          v-if="createLevelSelected && !levelHasAffectation && !checkingLevel"
          :message="$t('etablissement.levelRequiredFirst')"
          type="warning"
          show-icon
          style="margin-bottom: 16px"
        />
        <a-form-item :label="$t('etablissement.fraisInscri')">
          <a-input
            type="number"
            step="0.5"
            :disabled="feesLocked"
            v-decorator="[
              'inscription',
              {
                rules: [
                  {
                    required: false,
                    min: 0,
                    message: $t('requis.fraisInscri'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-divider>{{ $t("etablissement.fraisMensuelle") }}</a-divider>

        <a-form-item :label="$t('etablissement.fraisMensuel')">
          <a-input
            type="number"
            step="0.5"
            button-style="solid"
            :disabled="feesLocked"
            v-decorator="[
              'monthly',
              {
                rules: [
                  {
                    required: true,
                    min: 0,
                    message: $t('requis.fraisMensuel'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-divider>{{ $t("liste.fraisTranches") }}</a-divider>
        <a-form-item>
          <a-row v-for="(item, index) in tranchesList" :key="index">
            <a-col :span="3">
              {{ $t("etablissement.tranche") }} {{ item.trancheNumber }} :
            </a-col>
            <a-col :span="11">
              <a-select
                v-model="item.months"
                mode="multiple"
                style="width: 100%"
                :disabled="feesLocked"
                :placeholder="$t('profil.mois')"
              >
                <a-select-option
                  v-for="i in monthRangesList"
                  :key="i"
                  :value="i"
                >
                  {{ moment(i).format("MMMM") }}
                </a-select-option>
              </a-select></a-col
            >
            <a-col :span="8">
              <a-input-number
                style="width: 100%"
                class="ml-2"
                :value="item.amount"
                v-model="item.amount"
                :min="0"
                :disabled="feesLocked"
                :placeholder="$t('paymentStatus.montant')"
            /></a-col>
            <a-col :span="2">
              <a-button
                v-if="!feesLocked"
                type="dashed"
                class="ml-4"
                shape="circle"
                icon="delete"
                @click="
                  () => {
                    tranchesList.splice(index, 1);
                  }
                "
              />
            </a-col>
          </a-row>
          <a-row v-if="!feesLocked">
            <a-col :span="8"></a-col>
            <a-col :span="14">
              <a-button
                type="primary"
                class="mr-3 m-auto"
                @click="
                  () => {
                    tranchesList.push({
                      trancheNumber: tranchesList.length + 1,
                      amount: undefined,
                      months: [],
                    });
                  }
                "
              >
                {{ $t("etablissement.addTranche") }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <div class="form-actions mt-0">
          <a-button
            style="width: 150px"
            type="primary"
            htmlType="submit"
            :loading="loadingClasse"
            :disabled="loadingClasse || !levelHasAffectation"
            class="mr-3"
            >{{ $t("action.ajouter") }}</a-button
          >
          <a-button
            key="back"
            @click="handleCancel"
            :disabled="loadingClasse"
            >{{ $t("action.annuler") }}</a-button
          >
        </div>
      </a-form>
    </a-modal>
    <a-table
      :loading="tableLeading"
      :rowKey="'_id'"
      :columns="columns"
      :data-source="data"
      :pagination="true"
      :scroll="{ x: 'max-content' }"
    >
      <template
        v-for="col in ['name', 'schoolarYear', 'createdAt']"
        :slot="col"
        slot-scope="text"
      >
        <div v-if="!['createdAt', 'schoolarYear'].includes(col)" :key="col">
          <template>{{ text }}</template>
        </div>
        <div v-else :key="col" style="text-align: center">
          <template>{{ text }}</template>
        </div>
      </template>
      <template slot="level" slot-scope="text">
        <div style="text-align: center">
          {{ getLevelLabel(Number(text)) }}
        </div>
      </template>
      <template slot="tranches" slot-scope="text">
        <li v-for="t in text" :key="t.trancheNumber">
          {{ $t("etablissement.tranche") }} {{ t.trancheNumber }} :
          {{ t.amount }}
        </li>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a-button type="primary" @click="() => edit(record)">
          <a-icon type="edit" />
          {{ $t("action.modifier") }}
        </a-button>
      </span>
      <span slot="operationSupprimer" slot-scope="text, record">
        <a-button type="danger">
          <a-popconfirm
            :title="$t('requis.supp')"
            @confirm="() => supp(record._id)"
          >
            <a>{{ $t("action.supprimer") }}</a>
          </a-popconfirm>
        </a-button>
      </span>
    </a-table>
    <!-- UPDATE DRAWER -->
    <a-drawer
      v-if="updateDrawer"
      :title="$t('action.modifier') + ' ' + selectedClassRoom.name"
      :width="720"
      :visible="updateDrawer"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose('update')"
    >
      <a-form :form="updateForm" :key="formKey">
        <a-form-item :label="$t('etablissement.nom')">
          <a-input
            :placeholder="$t('etablissement.nom')"
            v-decorator="[
              'name',
              {
                initialValue: selectedClassRoom.name,
                rules: [
                  {
                    required: true,
                    message: $t('all.requiredName'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item :label="$t('etablissement.niveau')">
          <a-select
            @change="onUpdateLevelChange"
            v-decorator="[
              'level',
              {
                initialValue: selectedClassRoom.level.toString(),
                rules: [
                  {
                    required: true,
                    message: $t('requis.niveau'),
                  },
                ],
              },
            ]"
            :placeholder="$t('choisir.niveauClass')"
          >
            <a-select-option
              v-for="(value, name) in levelSelectData"
              :key="name"
              :value="name"
              >{{ value }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('etablissement.fraisInscri')">
          <a-input
            type="number"
            step="0.5"
            :disabled="updateFeesLocked"
            v-decorator="[
              'inscription',
              {
                initialValue: selectedClassRoom.inscription.toString(),
                rules: [
                  {
                    required: true,
                    min: 0,
                    message: $t('requis.fraisInscri'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-divider>{{ $t("etablissement.fraisMensuelle") }}</a-divider>
        <a-form-item :label="$t('etablissement.fraisMensuel')">
          <a-input
            type="number"
            step="0.5"
            button-style="solid"
            :disabled="updateFeesLocked"
            v-decorator="[
              'monthly',
              {
                initialValue: selectedClassRoom.monthly.toString(),
                rules: [
                  {
                    required: true,
                    min: 0,
                    message: $t('requis.fraisMensuel'),
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-divider>{{ $t("liste.fraisTranches") }}</a-divider>
        <a-form-item>
          <a-row v-for="(item, index) in selectedTranches" :key="index">
            <a-col :span="3">
              {{ $t("etablissement.tranche") }} {{ item.trancheNumber }} :
            </a-col>
            <a-col :span="11">
              <a-select
                v-model="item.months"
                mode="multiple"
                style="width: 100%"
                :disabled="updateFeesLocked"
                :placeholder="$t('profil.mois')"
              >
                <a-select-option
                  v-for="i in monthRangesList"
                  :key="i"
                  :value="i"
                >
                  {{ moment(i).format("MMMM") }}
                </a-select-option>
              </a-select></a-col
            >
            <a-col :span="8">
              <a-input-number
                style="width: 100%"
                class="ml-2"
                :min="0"
                :value="item.amount"
                v-model="item.amount"
                :disabled="updateFeesLocked"
                :placeholder="$t('paymentStatus.montant')"
            /></a-col>
            <a-col :span="2">
              <a-button
                v-if="!updateFeesLocked"
                type="dashed"
                class="ml-4"
                shape="circle"
                icon="delete"
                @click="
                  () => {
                    selectedTranches.splice(index, 1);
                  }
                "
              />
            </a-col>
          </a-row>
          <a-row v-if="!updateFeesLocked">
            <a-col :span="8"></a-col>
            <a-col :span="14">
              <a-button type="primary" class="mr-3 m-auto" @click="addTranche">
                {{ $t("etablissement.addTranche") }}
              </a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose('update')">{{
          $t("action.annuler")
        }}</a-button>
        <a-button
          type="primary"
          @click="save"
          :loading="loadingClasse"
          :disabled="loadingClasse"
          >{{ $t("action.modifier") }}</a-button
        >
      </div>
    </a-drawer>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import moment from "moment";
import { mapState } from "vuex";
import { getRangeMonthsSY } from "@/utilities/settings";
import { getLevels, getAllLevels } from "@/config/LevelConstants";
import { showApiError } from "@/utilities/showApiError";

var classesData = [];
export default {
  name: "classes",
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
    allLevels() {
      return getAllLevels(this.$t.bind(this), this.countryCode);
    },
    canEditClassroomFees() {
      const access = this.user.access || {};
      return (
        access.all === true ||
        (Array.isArray(access.parametrage) &&
          access.parametrage.includes("modifier_frais_classe"))
      );
    },
    columns() {
      return [
        {
          title: this.$t("etablissement.nom"),
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
          sorter: (a, b) => a.name.length - b.name.length,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.niveau"),
          dataIndex: "level",
          key: "level",
          width: "150px",
          scopedSlots: { customRender: "level" },
          sorter: (a, b) => a.level - b.level,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.fraisInscri"),
          dataIndex: "inscription",
          key: "inscription",
          scopedSlots: { customRender: "inscription" },
          sorter: (a, b) => a.inscription - b.inscription,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.fraisMensuel"),
          dataIndex: "monthly",
          key: "monthly",
          scopedSlots: { customRender: "monthly" },
          sorter: (a, b) => a.monthly - b.monthly,
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.tranches"),
          dataIndex: "tranches",
          key: "tranches",
          scopedSlots: { customRender: "tranches" },
        },
        {
          title: this.$t("etablissement.anneeScolaire"),
          dataIndex: "schoolarYear",
          key: "schoolarYear",
          scopedSlots: { customRender: "schoolarYear" },
          sortDirections: ["descend", "ascend"],
        },
        {
          title: this.$t("etablissement.dateCreation"),
          dataIndex: "createdAt",
          key: "createdAt",
          scopedSlots: { customRender: "createdAt" },
        },
        {
          title: this.$t("all.edit"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "operationSupprimer",
          scopedSlots: { customRender: "operationSupprimer" },
          fixed: "right",
        },
      ];
    },
  },
  beforeMount() {
    this.form = this.$form.createForm(this, { name: "classForm" });
    this.updateForm = this.$form.createForm(this, {
      name: "updateClassForm",
    });
  },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - Classes",
    });

    this.getClassRooms();
    this.schoolType = this.activeBuilding.type;
    this.monthRangesList = getRangeMonthsSY(
      this.settings.activeSchoolarYear,
      this.settings.schoolarYears
    );
    console.log(this.monthRangesList);
  },
  data() {
    return {
      moment,
      schoolType: null,
      photo: null,
      fileList2: [],
      fileList1: [],
      fileList3: [],
      tranchesList: [],
      monthRangesList: [],
      selectedClassRoom: {},
      selectedTranches: [],
      formKey: 0,
      updateDrawer: false,
      tableLeading: true,
      visibleModal: false,
      form: this.$form.createForm(this),
      updateForm: this.$form.createForm(this),
      data: null,
      cacheData: null,
      loadingClasse: false,
      editingKey: "",
      // Fee-defaulting from the level (affectation) classroom.
      feesLocked: false,
      levelHasAffectation: false,
      createLevelSelected: false,
      checkingLevel: false,
      updateFeesLocked: false,
    };
  },
  methods: {
    getLevelLabel(level) {
      return this.allLevels[String(level)] || "";
    },
    addTranche() {
      this.selectedTranches.push({
        trancheNumber: this.selectedTranches.length + 1,
        amount: undefined,
        months: [],
      });
    },
    // Fetch the level (affectation) classroom that holds the fee defaults for a
    // given level in the active school year, or null when none exists.
    async fetchAffectationForLevel(levelKey) {
      const res = await apiClient.post("/classrooms/filter", {
        query: {
          schoolarYear: this.settings.activeSchoolarYear,
          status: "active",
          classroomType: "affectation",
          level: Number(levelKey),
        },
      });
      return res.data && res.data.length ? res.data[0] : null;
    },
    async onCreateLevelChange(levelKey) {
      this.createLevelSelected = true;
      this.checkingLevel = true;
      this.feesLocked = false;
      this.levelHasAffectation = false;
      try {
        const level = await this.fetchAffectationForLevel(levelKey);
        if (level) {
          this.levelHasAffectation = true;
          // Prefill from level; lock unless the role may override fees.
          this.feesLocked = !this.canEditClassroomFees;
          this.tranchesList = (level.tranches || []).map((t) => ({ ...t }));
          this.$nextTick(() => {
            this.form.setFieldsValue({
              inscription:
                level.inscription != null ? String(level.inscription) : "0",
              monthly: level.monthly != null ? String(level.monthly) : "0",
            });
          });
        } else {
          // Per requirement: a normal classroom requires its level to exist first.
          this.tranchesList = [];
          this.form.setFieldsValue({
            inscription: undefined,
            monthly: undefined,
          });
        }
      } catch (e) {
        showApiError(this, e);
      } finally {
        this.checkingLevel = false;
      }
    },
    async onUpdateLevelChange(levelKey) {
      this.updateFeesLocked = false;
      try {
        const level = await this.fetchAffectationForLevel(levelKey);
        if (level) {
          this.updateFeesLocked = !this.canEditClassroomFees;
          this.selectedTranches = (level.tranches || []).map((t) => ({ ...t }));
          this.$nextTick(() => {
            this.updateForm.setFieldsValue({
              inscription:
                level.inscription != null ? String(level.inscription) : "0",
              monthly: level.monthly != null ? String(level.monthly) : "0",
            });
          });
        }
        // If no affectation exists (legacy classroom), keep fields editable.
      } catch (e) {
        showApiError(this, e);
      }
    },
    async getClassRooms() {
      await apiClient
        .post("/classrooms/filter", {
          query: {
            schoolarYear: this.settings.activeSchoolarYear,
            status: "active",
          },
          aggregation: {
            $project: {
              __v: 0,
              updatedAt: 0,
              teachers: 0,
            },
          },
        })
        .then((res) => {
          classesData = [...res.data];
          classesData = classesData.map((elem) => {
            var sc = "";
            try {
              sc = this.settings.schoolarYears.filter(
                (s) => s._id == elem.schoolarYear
              )[0].name;
            } catch {
              sc = "-";
            }
            return {
              ...elem,
              key: elem._id,
              createdAt: moment(elem.createdAt).format("DD/MM/YYYY"),
              schoolarYear: sc,
            };
          });
          this.data = classesData;
          this.cacheData = classesData.map((item) => ({ ...item }));
          this.tableLeading = false;
        })
        .catch((e) => this.$message.error(this.$t("error.aucClasse")));
    },

    onClose(type) {
      this.updateDrawer = false;
    },

    addClass(e) {
      e.preventDefault();
      console.log(this.tranchesList);
      const thereEmpty = this.tranchesList.filter(
        (s) => !s.trancheNumber || !s.amount
      );

      if (thereEmpty.length > 0) {
        this.$message.warning(this.$t("etablissement.verifierTranches"));
        return;
      }
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.loadingClasse = true;
          values.level = Number(values.level);
          values.tranches = this.tranchesList;
          apiClient
            .put("/classrooms", { data: values })
            .then((res) => {
              this.$message.success(this.$t("success.classeAjout"));
              res.data.key = res.data._id;
              this.data.push(this.prepareClaasRoom(res.data));
              this.cacheData.push(this.prepareClaasRoom(res.data));
              this.handleCancel();
            })
            .catch((e) => {
              console.error(e);
              this.$message.error(this.$t("error.impoAjoutClasse"));
            })
            .finally(() => (this.loadingClasse = false));
        }
      });
    },
    prepareClaasRoom(classroom) {
      var sc = "";
      try {
        sc = this.settings.schoolarYears.filter(
          (s) => s._id == classroom.schoolarYear
        )[0].name;
      } catch {
        sc = "-";
      }
      return {
        ...classroom,
        key: classroom._id,
        createdAt: moment(classroom.createdAt).format("DD/MM/YYYY"),
        schoolarYear: sc,
      };
    },
    showModal() {
      this.visibleModal = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.tranchesList = [];
      this.feesLocked = false;
      this.levelHasAffectation = false;
      this.createLevelSelected = false;
      this.checkingLevel = false;
      this.visibleModal = false;
    },

    edit(record) {
      this.selectedClassRoom = { ...record };
      if (!this.selectedClassRoom.tranches) this.selectedTranches = [];
      else
        this.selectedTranches = this.selectedClassRoom.tranches.map((t) => ({
          ...t,
        }));

      this.updateFeesLocked = false;
      this.formKey += 1;
      this.updateDrawer = true;
      // Without override permission, lock and re-sync fees from the level.
      // With permission, keep the classroom's own fees editable.
      if (this.selectedClassRoom.level != null) {
        if (this.canEditClassroomFees) {
          this.updateFeesLocked = false;
        } else {
          this.onUpdateLevelChange(this.selectedClassRoom.level);
        }
      }
    },
    save(e) {
      e.preventDefault();

      this.loadingClasse = true;
      this.updateForm.validateFieldsAndScroll((err, values) => {
        console.log(values);
        if (!err) {
          const updates = {
            name: values.name,
            inscription: values.inscription,
            monthly: values.monthly,
            level: values.level,
            tranches: this.selectedTranches,
          };
          apiClient
            .patch("/classrooms/" + this.selectedClassRoom._id, {
              data: updates,
            })
            .then(() => {
              this.$message.success(this.$t("success.classeMSA"));
              this.updateDrawer = false;
              this.getClassRooms();
            })
            .catch((e) => {
              console.error(e);
              this.$message.error(this.$t("error.modif"));
            })
            .finally(() => (this.loadingClasse = false));
        } else {
          console.log(err);
          this.loadingClasse = false;
        }
      });
    },

    supp(key) {
      apiClient
        .patch("/classrooms/" + key, { data: { status: "inactive" } })
        .then(() => {
          this.$message.success(this.$t("success.classeSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch(() => this.$message.error(this.$t("error.classeNonSupp")));
    },
  },
};
</script>
<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
>
